module.exports = {"id":"214685","name":"Patricio Rubio","rating":"71","photo":"./data/images/photos/3/214685.png","club":{"name":"CD Everton","logo":"./data/images/clubs/CDEverton.png"},"positions":["BU","AG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/PatricioRubio0.json
// module id = 3376
// module chunks = 0